
import { handlePostAction } from "../../../utils/event-api-invoke";
import { getEmailAPIPostSchema } from "../create/schema";

let _isError = false;

const getPostPayload = (data, loggedInUser, config) => {
    try {

        let _postSchema = {};
        _postSchema = getEmailAPIPostSchema(config.countryCode, config.businessCode, config.locale);

        _postSchema.emailDetails.toList = [data];
        _postSchema.emailDetails.bccList = [loggedInUser];
        return _postSchema;
    } catch (err) {
        _isError = true;
        alert(err);
    }
};

const sendEmailToApprover = async (approverEmail, uihandler) => {
    let status = {
        responseStatus: null,
        error: null,
    };
    const {
        email: { loggedInUser },
        settingsConfig: { businessCode, countryCode, locale }
    } = uihandler;
    try {
        console.log(loggedInUser);
        let _postPayload = getPostPayload(approverEmail, loggedInUser, { businessCode, countryCode, locale });

        let _postRequest = { ..._postPayload };

        let res = await handlePostAction(_postRequest, "sendEmail");
        if (res && res.status && res.status === 200) {
            if (res.data.errorNumber > 0) {
                _isError = true;
                status.errorMessage = res.data.errorDescription;
            } else {
                status.responseStatus = res.status;
            }
        }

    } catch (err) {
        _isError = true;
        alert(err);
    } finally {
        return { ...status, error: _isError };
    }
};

export { sendEmailToApprover };